import { Alert, Avatar, Button, Empty, Layout, List, Space, Spin, Tag, Tooltip, Typography } from 'antd';
import { LinkOutlined, PhoneOutlined, ReloadOutlined, UserOutlined } from '@ant-design/icons';
import { serverFetch } from '@api/server';

const { Sider } = Layout;
const { Text, Title } = Typography;

const FALLBACK_CHANNEL_NAMES = {
  1: 'SIP',
  2: 'MAX',
  3: 'Виджет',
  4: 'VK',
  5: 'Bitrix24',
  6: 'External',
  7: 'Чат',
};

export const formatDate = (value) => {
  if (!value) {
    return '';
  }

  return new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value));
};

export const getDialogTitle = (dialog) => (
  dialog.userphone || dialog.channeluserid || `Диалог #${dialog.id}`
);

export const getDialogs = () => serverFetch('dialog');

export const getDialogContext = (dialogId) => serverFetch(`dialog/context/${dialogId}`);

export const clearDialogContext = (dialogId) => serverFetch(`dialog/clear_context/${dialogId}`, {
  method: 'PUT',
});

const Dialogs = ({
  dialogs,
  dialogsError,
  isDialogsLoading,
  selectedDialogId,
  onSelectDialog,
  onReloadDialogs,
  channelNames = {},
}) => {
  return (
    <Sider className="dialogs-sider" width={360} theme="light">
      <div className="panel-title">
        <Space size={8}>
          <Title level={5}>Диалоги</Title>
          <Text type="secondary">{dialogs.length}</Text>
        </Space>
        <Button
          icon={<ReloadOutlined />}
          onClick={onReloadDialogs}
          loading={isDialogsLoading}
          size="small"
        >
          Обновить
        </Button>
      </div>

      {dialogsError && (
        <Alert className="panel-alert" type="error" message={dialogsError} showIcon />
      )}

      <Spin spinning={isDialogsLoading}>
        <List
          className="dialogs-list"
          dataSource={dialogs}
          locale={{ emptyText: <Empty description="Диалогов пока нет" /> }}
          renderItem={(dialog) => (
            <List.Item
              className={dialog.id === selectedDialogId ? 'dialog-item dialog-item-active' : 'dialog-item'}
              onClick={() => onSelectDialog(dialog.id)}
            >
              <List.Item.Meta
                avatar={<Avatar icon={dialog.userphone ? <PhoneOutlined /> : <UserOutlined />} />}
                title={
                  <Space size={8} wrap>
                    <Text strong>{getDialogTitle(dialog)}</Text>
                    <Tag>
                      {channelNames[dialog.channelvid]
                        || FALLBACK_CHANNEL_NAMES[dialog.channelvid]
                        || `Канал ${dialog.channelvid}`}
                    </Tag>
                    {dialog.url && (
                      <Tooltip title={dialog.url}>
                        <LinkOutlined
                          className="dialog-url-icon"
                          onClick={(event) => event.stopPropagation()}
                        />
                      </Tooltip>
                    )}
                  </Space>
                }
                description={
                  <Space size={8}>
                    <span>{formatDate(dialog.updatedon)}</span>
                    <span># {dialog.id}</span>
                  </Space>
                }
              />
            </List.Item>
          )}
        />
      </Spin>
    </Sider>
  );
};

export default Dialogs;
